import i18n from "@/libs/i18n";
import { computed, ref, watch } from "@vue/composition-api";
import axios from "@/libs/axios";

export default function useIpWhitelistingList(bvModal = undefined) {
    const refTable = ref(null);
    const tableColumns = [{ key: "name", sortable: true }, { key: "ipAddress", sortable: true }, { key: "actions" }];
    const perPage = ref(10);
    const total = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref("");
    const sortBy = ref("name");
    const isSortDirDesc = ref(false);
    const ownIp = ref("");
    ownIp.value = i18n.t("settings.ip-whitelisting.unknown");

    const fetchIp = () => {
        return axios.get("/whitelisted-ips/ip").then((result) => (ownIp.value = result.data));
    };

    const dataMeta = computed(() => {
        const localItemsCount = refTable.value ? refTable.value.localItems.length : 0;

        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: total.value,
        };
    });

    const refetchData = () => {
        refTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery], () => {
        if (searchQuery.value.length > 0 && searchQuery.value.length < 2) {
            return;
        }

        refetchData();
    });

    const read = (ctx, callback) => {
        axios
            .get("/whitelisted-ips", {
                params: {
                    fields: "name,ipAddress",
                    s: {
                        $or: [{ name: { $cont: searchQuery.value } }, { ipAddress: { $cont: searchQuery.value } }],
                    },
                    limit: perPage.value,
                    page: currentPage.value,
                    sort: `${sortBy.value},${isSortDirDesc.value === true ? "DESC" : "ASC"}`,
                },
            })
            .then((response) => {
                callback(response.data.data);
                total.value = response.data.total;
            });
    };

    const deleteOne = ({ id, name }, callback) => {
        if (!bvModal) {
            throw new Error("IpWhitelisting not initialised correctly for deletion");
        }

        bvModal
            .msgBoxConfirm(i18n.t("confirm.Are you sure?"), {
                title: i18n.t("confirm.Are you sure?"),
                cancelTitle: i18n.t("confirm.Cancel"),
                cancelVariant: "light",
                okTitle: i18n.t("confirm.Yes, delete"),
                hideHeaderClose: false,
                headerCloseVariant: "light",
                centered: true,
                bodyClass: "mx-auto",
                headerClass: "text-center",
            })
            .then((result) => {
                if (result) {
                    axios.delete(`/whitelisted-ips/${id}`).then((response) => {
                        callback(response);
                    });
                }
            });
    };

    return {
        read,
        deleteOne,
        refetchData,
        fetchIp,
        tableColumns,
        perPage,
        currentPage,
        total,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refTable,
        ownIp,
    };
}
